import { Injectable } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../api-service/api.service';

@Injectable({ providedIn: 'root' })
export class UserDismissalService {
  BASE_URL = '/_ajax/v1/user-dismissal/';
  CHECK_URL: string = this.BASE_URL + 'check/';
  DISMISS_URL: string = this.BASE_URL + 'dismiss/';
  UNDISMISS_URL: string = this.BASE_URL + 'undismiss/';

  TUTORIAL_WIDGET_CONTENT_ID = 'partner-center-intro-widget';

  private showTutorialWidget: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  get IsLoading(): Observable<boolean> {
    return this.loading.asObservable();
  }

  get ShowTutorialWidget(): Observable<boolean> {
    return this.showTutorialWidget.asObservable();
  }

  constructor(
    private apiService: ApiService,
    private snackbarService: SnackbarService,
  ) {}

  checkTutorialWidget(): void {
    this.loading.next(true);
    const body = { contentId: this.TUTORIAL_WIDGET_CONTENT_ID };
    this.apiService.post(this.CHECK_URL, body).subscribe(
      (hasDismissed: boolean) => {
        this.showTutorialWidget.next(!hasDismissed);
      },
      () => {
        this.snackbarService.errorSnack('error loading page');
      },
      () => {
        this.loading.next(false);
      },
    );
  }

  dismissTutorialWidget(): void {
    const body = { contentId: this.TUTORIAL_WIDGET_CONTENT_ID };
    this.apiService.post(this.DISMISS_URL, body).subscribe({
      next: () => {
        this.showTutorialWidget.next(false);
      },
      error: () => {
        this.snackbarService.errorSnack('error dismissing widget');
      },
    });
  }

  unDismissTutorialWidget(): void {
    const body = { contentId: this.TUTORIAL_WIDGET_CONTENT_ID };
    this.apiService.post(this.UNDISMISS_URL, body).subscribe({
      next: () => {
        this.showTutorialWidget.next(true);
      },
      error: () => {
        this.snackbarService.errorSnack('error retrieving widget');
      },
    });
  }
}
